import type { Time } from '@lt/api/dist/types/date';

export const minutesToTimeFormat = (minutes: number): Time => {
  const hours = Math.floor(minutes / 60);
  const formattedHours = hours % 24;
  const formattedMinutes = minutes % 60;
  return `${formattedHours < 10 ? `0${formattedHours}` : formattedHours}:${
    formattedMinutes < 10 ? `0${formattedMinutes}` : formattedMinutes
  }`;
};

export const convertToMinutes = (time: string): number => {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
};
